/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehiclePaginationResponseAllOfDataInner } from './VehiclePaginationResponseAllOfDataInner';
import {
    VehiclePaginationResponseAllOfDataInnerFromJSON,
    VehiclePaginationResponseAllOfDataInnerFromJSONTyped,
    VehiclePaginationResponseAllOfDataInnerToJSON,
    VehiclePaginationResponseAllOfDataInnerToJSONTyped,
} from './VehiclePaginationResponseAllOfDataInner';

/**
 * 
 * @export
 * @interface VehiclePaginationResponse
 */
export interface VehiclePaginationResponse {
    /**
     * 全体件数
     * @type {number}
     * @memberof VehiclePaginationResponse
     */
    totalCount?: number;
    /**
     * 現在のページ番号
     * @type {number}
     * @memberof VehiclePaginationResponse
     */
    page?: number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof VehiclePaginationResponse
     */
    count?: number;
    /**
     * 総ページ数
     * @type {number}
     * @memberof VehiclePaginationResponse
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<VehiclePaginationResponseAllOfDataInner>}
     * @memberof VehiclePaginationResponse
     */
    data?: Array<VehiclePaginationResponseAllOfDataInner>;
}

/**
 * Check if a given object implements the VehiclePaginationResponse interface.
 */
export function instanceOfVehiclePaginationResponse(value: object): value is VehiclePaginationResponse {
    return true;
}

export function VehiclePaginationResponseFromJSON(json: any): VehiclePaginationResponse {
    return VehiclePaginationResponseFromJSONTyped(json, false);
}

export function VehiclePaginationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehiclePaginationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'page': json['page'] == null ? undefined : json['page'],
        'count': json['count'] == null ? undefined : json['count'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(VehiclePaginationResponseAllOfDataInnerFromJSON)),
    };
}

export function VehiclePaginationResponseToJSON(json: any): VehiclePaginationResponse {
    return VehiclePaginationResponseToJSONTyped(json, false);
}

export function VehiclePaginationResponseToJSONTyped(value?: VehiclePaginationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'page': value['page'],
        'count': value['count'],
        'totalPages': value['totalPages'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(VehiclePaginationResponseAllOfDataInnerToJSON)),
    };
}

